import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openMiniUploadBox } from "../../store/slices/Gallery/fileUploadSlce";

export const useFileUploadMini = () => {
    const dispatch = useDispatch()
    const fileUploadState = useSelector((state) => state.fileUpload);


    const closeMiniModal = () => {

        dispatch(openMiniUploadBox(false));

    }


    return {
        closeMiniModal,
        fileUploadState
    }
}